<div class="scroll-container" style="overflow-y: auto;" [style.height]="getDynamicHeight()">
    <table class="table table-striped table-hover table-sm table-max-width">
        <thead style="position: sticky;top: 0;">
            <tr>
                <th *ngIf="!isMeddraHierarchy()"  style="cursor: pointer;position: sticky;top: 0;overflow: hidden; text-overflow: ellipsis;"                     
                [columnIndex]="0"
                storageKey="'itemsTable:Num"
                appResizableColumn><a (click)="sortByNum()" style="cursor: pointer;">Num {{sortIcon('-1')}}</a></th>
                <th *ngFor="let column of this.selectedNode.data.itemFinderTreeColumns;let i = index" 
                    style="cursor: pointer;white-space: nowrap;position: sticky;top: 0;overflow: hidden; text-overflow: ellipsis;"                 
                    [columnIndex]="i"
                storageKey="'itemsTable:'{{column.getSourceName()}}"
                appResizableColumn><a (click)="sortBy(column)" style="cursor: pointer;">{{ column.getHeader() }}
                        {{sortIcon(column.getSourceName())}}</a></th>
            </tr>
        </thead>
        <tbody *ngIf="!this.selectedNode.showResults">
            <tr *ngFor="let item of this.selectedNode.children">
                <td *ngIf="!isMeddraHierarchy()" style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;"><input type="checkbox"  class="mr-5" [checked]="item.checked" (change)="select($event, item)"/>&nbsp;<span>{{item.num}}</span></td>
                <td *ngFor="let column of this.selectedNode.data.itemFinderTreeColumns" (click)="onItemFinderDoubleClick(item)"
                    style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                    {{ this.displayValue(item.data.model[column.getSourceName()],column.getDataType(), column.getLookup())}}</td>
            </tr>
        </tbody>
    </table>
</div>